import { Component, Input, ElementRef, OnChanges, ViewChild, AfterViewInit } from '@angular/core';

declare var jQuery: any; 

@Component({
  selector: 'itpx-video-tile',
  templateUrl: './video-tile.component.html',
  styleUrls: ['./video-tile.component.css']
})
export class VideoTileComponent implements AfterViewInit {

  @Input() title: string;
  @Input() id : string;
  @Input() srcVideo: string;
  @Input() srcType: string;
  @Input() description: string;
  @Input() maxLength: number;
  @ViewChild('imgThumb') imgThumb;

  currentText: string;
  hideToggle: boolean = true;

  private isCollapsed: boolean = true;

  constructor( ) { }

  ngOnInit() { 
    let descriptionLength = this.description.length;
    if(descriptionLength > this.maxLength) {
      this.currentText = this.description.substring(0, this.maxLength) + '...';
    } else {
      this.currentText = this.description;
    };
  }

  ngAfterViewInit(){
    if(this.srcType == 'vimeo') {
      this.setThumbnailsImgVimeo(jQuery(this.imgThumb.nativeElement));
    } 
  }

  private setThumbnailsImgVimeo(el: any) {
    let vimeoVideoUrl = this.srcVideo;
    let match = /vimeo.*\/(\d+)/i.exec(vimeoVideoUrl);
    if (match) {
        let vimeoVideoID = match[1];
        jQuery.getJSON('https://www.vimeo.com/api/v2/video/' + vimeoVideoID + '.json?callback=?', function (data) {
            let imgSrc = data[0].thumbnail_large;
            el.attr('src', imgSrc);
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/video-tile/video-tile.component.ts